import React, { useEffect, useState } from 'react';

const Pronoun = {
  HE: 'he/him',
  SHE: 'she/her',
  THEY: 'they/them',
  OTHER: 'other',
};

function PronounPicker(props) {
  const [otherTxt, setOtherTxt] = useState('');
  const [radioVal, setRadioVal] = useState('');
  const [pronouns, setPronouns] = useState('');

  useEffect(() => {
    if (!props.pronouns) return;
    setPronouns(props.pronouns);
    if (props.pronouns === Pronoun.HE || props.pronouns === Pronoun.SHE || props.pronouns === Pronoun.THEY) {
      setRadioVal(props.pronouns);
    } else {
      setRadioVal(Pronoun.OTHER);
      setOtherTxt(props.pronouns);
    }
  }, [props.pronouns]);

  useEffect(() => props.savePronouns(pronouns), [pronouns]);

  const onRadChange = (e) => {
    if (e.target.name === Pronoun.OTHER) {
      setRadioVal(Pronoun.OTHER);
      setOtherTxt(e.target.value);
    } else {
      setRadioVal(e.target.value);
    }
    setPronouns(e.target.value);
    props.savePronouns(e.target.value);
  };

  const isChecked = (thisVal) => {
    if (radioVal === thisVal) return true;
    return false;
  };

  return (
    <form className="pronouns">
      <label htmlFor={Pronoun.THEY}>{Pronoun.THEY}<input type="radio"
        name="gender"
        id={Pronoun.THEY}
        value={Pronoun.THEY}
        checked={isChecked(Pronoun.THEY)}
        onChange={onRadChange}
      />
      </label>
      <label htmlFor={Pronoun.SHE}>{Pronoun.SHE}<input
        type="radio"
        name="gender"
        id={Pronoun.SHE}
        value={Pronoun.SHE}
        checked={isChecked(Pronoun.SHE)}
        onChange={onRadChange}
      />
      </label>
      <label htmlFor={Pronoun.HE}>{Pronoun.HE}<input
        type="radio"
        name="gender"
        id={Pronoun.HE}
        value={Pronoun.HE}
        checked={isChecked(Pronoun.HE)}
        onChange={onRadChange}
      />
      </label>
      <label htmlFor={Pronoun.OTHER}>
        <input
          type="radio"
          name="gender"
          id={Pronoun.OTHER}
          value={Pronoun.OTHER}
          onChange={onRadChange}
          checked={isChecked(Pronoun.OTHER)}
        />
        <input
          type="text"
          className="pronoun-other-input"
          name={Pronoun.OTHER}
          value={otherTxt}
          placeholder="or add yours here"
          id="other_text"
          onChange={onRadChange}
        />
      </label>
    </form>
  );
}

export default PronounPicker;
